<ng-container *transloco="let t">
  <div class="grid grid-cols-[min-content_1fr] gap-2">
    <label class="flex min-w-28 items-center">{{ t("tactic-add-popup.tactic_type") }}</label>
    <div>
      <ISelectMenu
        [value]="selectedTacticType()"
        (valueChange)="selectTacticType($event)"
        fitTriggerWidth
        data-testid="btn-tactic-toggle"
      >
        <ISelectTrigger class="flex w-full">
          <ISelectValue [placeholder]="t('common.select')">
            <div *iSelectValue="let value">{{ value.label }}</div>
          </ISelectValue>
        </ISelectTrigger>
        <ISelectContent>
          @for (option of tacticTypesOptions; track option.testid) {
            <ISelectOption [value]="option" [disabled]="option.disabled" [attr.data-testid]="option.testid">
              {{ option.label }}
            </ISelectOption>
          }
        </ISelectContent>
      </ISelectMenu>
    </div>
    <label>{{ t("common.segment") }}</label>
    <div>
      <ISelectMenu
        [value]="selectedSegment()"
        (valueChange)="selectSegment($event)"
        [(searchQuery)]="segmentSearchQuery"
        fitTriggerWidth
        data-testid="btn-segment-toggle"
      >
        <ISelectTrigger class="flex w-full">
          <ISelectValue [placeholder]="t('sd-strategy-creation.select_a_segment')">
            <div *iSelectValue="let value">
              @if (value === CREATE_NEW_SEGMENT) {
                {{ t("add-to-segment-modal.create_new_segment") }}
              } @else {
                {{ value.name }}
              }
            </div>
          </ISelectValue>
        </ISelectTrigger>
        <ISelectContent>
          <ISelectOption [value]="CREATE_NEW_SEGMENT" data-testid="btn-create-segment">
            {{ t("add-to-segment-modal.create_new_segment") }}
          </ISelectOption>
          @for (segment of filteredSegments(); track segment.segmentId) {
            <ISelectOption [value]="segment">
              {{ segment.name }}
            </ISelectOption>
          }
        </ISelectContent>
      </ISelectMenu>
    </div>
  </div>
  <div class="mt-6 flex justify-end gap-2">
    <button iButton variant="secondary" size="md" (click)="modalRef.close()">{{ t("common.cancel") }}</button>
    <button
      iButton
      class="w-2/4"
      type="submit"
      [disabled]="selectedSegment() === undefined"
      testId="btn-confirm"
      [loading]="isCreatingTactic()"
      (click)="create()"
    >
      {{ t("common.next") }}
    </button>
  </div>
</ng-container>
